module.exports = [
  {
    headline: "Have you used online dating sites?",
    left: { text: "Yes", id: "4721524007001" },
    right: { text: "No", id: "4721533281001" }
  },
  {
    headline: "What would you rather do?",
    left: { text: "Work hard", id: "4721524008001" },
    right: { text: "Play hard", id: "4721531072001" }
  },
  {
    headline: "What's your dating style?",
    left: { text: "Unlimited options", id: "4721524009001" },
    right: { text: "Careful curation", id: "4721533283001" }
  }
];